export const SceneType = {
    typing: "typing"
}

export const PianoSongs = {
    fast: "fast",
    slow: "slow"
}